// Owner: mail (wave 2, plan §9.7). The one way to write an e-mail from anywhere in the app: record
// headers, inbox items, the timeline's Reply, generated documents, AI drafts. Light module (no
// composer code): the composer layer loads on first open.
import type { MailAttachment, MailRecipient } from '@dataroom/core/communications';
import type { DocumentNode } from '@dataroom/core/doc/node';
import { openLayer } from '../../shell/overlays';

export type ComposeRequest = {
  /** To (records with an e-mail field, members, or plain addresses). */
  to?: MailRecipient[];
  cc?: MailRecipient[];
  bcc?: MailRecipient[];
  subject?: string;
  /** Plain text (one paragraph per line) or a block document. */
  body?: string | DocumentNode;
  /** Record files, uploads or assets (a generated document passes its asset). */
  attachments?: MailAttachment[];
  /** The record the message is about: the sent mail is linked to it. */
  recordRef?: { objectKey: string; recordId: string } | null;
  /** Apply a mail template (rendered for `recordRef`) when the composer opens. */
  templateId?: string;
  /** Open one of the member's drafts. */
  draftId?: string;
  /** Open the list of drafts and scheduled messages. */
  showDrafts?: boolean;
  /** Open the mail templates (list and editor) on their own. */
  showTemplates?: boolean;
  /** The task an e-mail task is answered from. */
  taskId?: string;
  /** Answering or passing on a message: the composer is titled "Reply" / "Forward". */
  kind?: 'reply' | 'forward';
  /** @deprecated Use `to`. */
  recipients?: MailRecipient[];
  /** @deprecated Use `recordRef`. */
  context?: { objectKey: string; recordId: string };
};

/** Open the mail composer layer (`composer`, src/overlays/communications.tsx). */
export function composeEmail(request: ComposeRequest = {}) {
  openLayer('composer', request);
}
